import _ from 'lodash'

export type DefSort = { [k: string]: any }
export type DefFilter = { [k: string]: any }
export type ExtendSort = string[][]

export default function createURLParams(
  limit?: number | string | null,
  offset?: number | string | null,
  sort?: DefSort | ExtendSort | null,
  filter?: DefFilter | null,
  extendFilter = true,
  extendSort = true
) {
  const params = new URLSearchParams()
  if (limit) {
    params.append('limit', limit.toString())
  }
  if (offset) {
    params.append('offset', offset.toString())
  }
  if (sort) {
    if (extendSort) {
      for (const sortElement of sort as ExtendSort) {
        params.append('sort', JSON.stringify(sortElement))
      }
    } else {
      params.append('sort', JSON.stringify(sort))
    }
  }
  if (filter) {
    if (extendFilter) {
      for (const [key, value] of Object.entries(filter)) {
        params.append(key, _.isString(value) ? value : JSON.stringify(value))
      }
    } else {
      params.append('filter', JSON.stringify(filter))
    }
  }
  return params
}
